export default __webpack_public_path__ + "static/media/twitter.9412c415.svg";